import _objectWithoutProperties from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["value", "id", "onFocus", "onBlur", "onChange"];
import React, { useMemo, useEffect, useCallback } from 'react';
import { useComboboxTextField } from '../../../../utilities/combobox/hooks.js';
import { TextField as TextField$1 } from '../../../TextField/TextField.js';
import { useUniqueId } from '../../../../utilities/unique-id/hooks.js';
import { labelID } from '../../../Label/Label.js';

function TextField(_ref) {
  var value = _ref.value,
      idProp = _ref.id,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var comboboxTextFieldContext = useComboboxTextField();
  var activeOptionId = comboboxTextFieldContext.activeOptionId,
      listboxId = comboboxTextFieldContext.listboxId,
      expanded = comboboxTextFieldContext.expanded,
      setTextFieldFocused = comboboxTextFieldContext.setTextFieldFocused,
      setTextFieldLabelId = comboboxTextFieldContext.setTextFieldLabelId,
      onTextFieldFocus = comboboxTextFieldContext.onTextFieldFocus,
      onTextFieldChange = comboboxTextFieldContext.onTextFieldChange,
      onTextFieldBlur = comboboxTextFieldContext.onTextFieldBlur;
  var uniqueId = useUniqueId('ComboboxTextField');
  var textFieldId = useMemo(function () {
    return idProp || uniqueId;
  }, [uniqueId, idProp]);
  var labelId = useMemo(function () {
    return labelID(idProp || uniqueId);
  }, [uniqueId, idProp]);
  useEffect(function () {
    if (setTextFieldLabelId) setTextFieldLabelId(labelId);
  }, [labelId, setTextFieldLabelId]);
  var handleFocus = useCallback(function () {
    if (onFocus) onFocus();
    if (onTextFieldFocus) onTextFieldFocus();
    if (setTextFieldFocused) setTextFieldFocused(true);
  }, [onFocus, onTextFieldFocus, setTextFieldFocused]);
  var handleBlur = useCallback(function () {
    if (onBlur) onBlur();
    if (onTextFieldBlur) onTextFieldBlur();
    if (setTextFieldFocused) setTextFieldFocused(false);
  }, [onBlur, onTextFieldBlur, setTextFieldFocused]);
  var handleChange = useCallback(function (value, id) {
    if (onChange) onChange(value, id);
    if (onTextFieldChange) onTextFieldChange();
  }, [onChange, onTextFieldChange]);
  return /*#__PURE__*/React.createElement(TextField$1, Object.assign({}, rest, {
    value: value,
    id: textFieldId,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: handleChange,
    ariaAutocomplete: "list",
    "aria-haspopup": "listbox",
    ariaActiveDescendant: activeOptionId,
    ariaControls: listboxId,
    role: "combobox",
    ariaExpanded: expanded
  }));
}

export { TextField };